import * as React from 'react';
import type { SVGProps } from 'react';

const IconConfirmEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 45" {...props}>
    <path
      d="m49.404 14.488-7.65-4.5V1.796a1.389 1.389 0 0 0-1.39-1.39H9.81a1.389 1.389 0 0 0-1.389 1.39v8.192l-7.65 4.5a1.39 1.39 0 0 0-.683 1.196v23.611a5.563 5.563 0 0 0 5.555 5.556h38.89a5.563 5.563 0 0 0 5.555-5.556v-23.61c0-.492-.26-.947-.684-1.197ZM11.198 3.184h27.778v18.448l-13.889 6.411-13.889-6.41V3.183ZM47.31 39.295a2.78 2.78 0 0 1-2.777 2.778H5.642a2.78 2.78 0 0 1-2.777-2.778V16.48L8.42 13.21v7.138l-.805-.371A1.39 1.39 0 1 0 6.448 22.5l18.056 8.334c.37.17.796.17 1.166 0L43.726 22.5a1.389 1.389 0 0 0-1.166-2.522l-.806.372v-7.14l5.556 3.268v22.817ZM23.7 22.63c-.369 0-.722-.147-.983-.407l-5.555-5.556a1.39 1.39 0 0 1 1.964-1.964l4.424 4.425 7.37-9.83a1.389 1.389 0 1 1 2.225 1.664L24.81 22.073a1.395 1.395 0 0 1-1.015.553c-.033.003-.065.003-.098.003Z"
      fill="#f32a52"
    />
  </svg>
);
export default IconConfirmEmail;
